import React from 'react';
import { Grid } from 'semantic-ui-react';
import EmailSender from './EmailSender';
import EmailIntegrations from './EmailIntegrations';
import EmailPreferences from './EmailPreferences';
import { useSelector } from 'react-redux';

const Email = () => {
    const active = useSelector((state) =>
        state.user.userProfile.active
    )
    return (
        <Grid>
            <Grid.Row>
                <Grid.Column>
                    <EmailSender active={active} />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <EmailIntegrations active={active}/>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <EmailPreferences active={active}/>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
};

export default Email;
